import React from 'react';

const Preloader = () => {
    return( 
        <div className="zb-loader-block">
            <div className="zb-loader-content">
                <span className="zb-loader" />
                <span className="zb-loader-text">Please wait, do not refresh</span>
            </div>
        </div>
    );
}
export default Preloader;